import * as React from 'react';
import { useEffect } from 'react';

import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { clientTermText } from '../../../constants/StaticText';
import Header from '../../uiParts/Header';
import StaticTextCard from '../../uiParts/StaticTextCard';

const ClientTerm: React.FC = (): JSX.Element => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('title.common.clientTerm');
  });

  return (
    <>
      <Header />
      <Typography component="div" sx={{ marginTop: '24px' }}>
        <StaticTextCard content={clientTermText()} />
      </Typography>
    </>
  );
};

export default ClientTerm;
